import { render } from "./alarm-comments.vue?vue&type=template&id=2f9c26b0&ts=true"
import script from "./alarm-comments.vue?vue&type=script&lang=ts"
export * from "./alarm-comments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__